// ** Routes Imports
import AppRoutes from "./Apps";
import FormRoutes from "./Forms";
import PagesRoutes from "./Pages";
import TablesRoutes from "./Tables";
import ChartsRoutes from "./Charts";
import DashboardRoutes from "./Dashboards";
import UiElementRoutes from "./UiElements";
import ExtensionsRoutes from "./Extensions";
import PageLayoutsRoutes from "./PageLayouts";
import DemoRoutes from "./Demo";
import ProductsRoutes from "./Products";
import UsersRoutes from "./Users";
import CiroRoutes from "./Ciro";
import SalesRoutes from "./Sales";
import AzSalesRoutes from "./AzSales";
import CouponsRoutes from "./Coupons";
import ReferenceRoutes from "./Reference";
import RefundsRoutes from "./Refunds";
import RisksRoutes from "./Risks";
import OnboardingRoutes from "./Onboarding";
import AuthRoutes from "./Auth";
import PFConfigRoutes from "./PFConfig";
import Rbcr from "./Rbcr";
import RegionConfigRoutes from "./RegionConfig";

// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template";

// ** Default Route
const DefaultRoute = "/merchants";

// ** Merge Routes
const Routes = [
  ...DemoRoutes,
  ...ProductsRoutes,
  ...UsersRoutes,
  ...CiroRoutes,
  ...SalesRoutes,
  ...AzSalesRoutes,
  // ...CouponsRoutes,
  ...ReferenceRoutes,
  ...RefundsRoutes,
  ...RisksRoutes,
  ...OnboardingRoutes,
  ...AuthRoutes,
  ...DashboardRoutes,
  ...AppRoutes,
  ...PagesRoutes,
  ...UiElementRoutes,
  ...ExtensionsRoutes,
  ...PageLayoutsRoutes,
  ...FormRoutes,
  ...TablesRoutes,
  ...ChartsRoutes,
  ...PFConfigRoutes,
  ...Rbcr,
  ...RegionConfigRoutes,
];

export { DefaultRoute, TemplateTitle, Routes };
